export default __webpack_public_path__ + "static/media/profile_bg.62ecc10c.png";